
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { Guard } from "@/store/dispatch/types";
import { TaskGroup, EventTask, Task } from "@/store/tasks/types";
import { CompleteTaskPayload } from "@/services/api.service";

import CompleteTaskLine from "@/components/tasks/CompleteTaskLine.vue";
import { BCarousel } from "bootstrap-vue/src/components/carousel";

const Mobile = namespace("mobile");
const SiteMonitor = namespace("siteMonitor");
const Tasks = namespace("tasks");

@Component({
    components: {
        "complete-task-line": CompleteTaskLine
    }
})
export default class MobileEventTask extends Vue {
    @Prop() public tasks: Task[];
	@Prop() public eventId: number;

    @Ref() taskCarousel: BCarousel;
	@Ref() completeTaskLine: CompleteTaskLine;

    @Tasks.Action completeTask: (payload: CompleteTaskPayload) => void;
    @Tasks.Action fetchEventTasks: ({ eventId }) => Promise<void>;
    @Tasks.Action assignTask: (payload) => void;
    @Tasks.Mutation resetCompletedTasks: (tasks: Task[]) => void;

    @SiteMonitor.Mutation setActivity: () => void;
    @SiteMonitor.Getter("getEventShare") eventShares: any[];

    @Getter getFeature: (featureNames: string[]) => boolean;

    private showCompletedTasks: boolean = false;
    private currentTask: Task = null;
    private currentSlide: number = 0;
    private sliding: boolean = false;
    private isRedoing: boolean = false;

    private created() {
		if (this.tasks && this.tasks.length > 0) {
			this.currentTask = this.tasks[0];
		}
	}

    private get currentActionIsRequired(): boolean {
		return this.currentTask && !this.currentTask.completed && this.currentTask.required;
	}

    private get tasksFinished(){
        return this.tasks.length == this.tasks.filter(f => f.completed).length;
    }

    public async onAssignTaskToUser(eventTaskID: string, eventUserID: string) {
		await this.assignTask({
			eventID: this.eventId,
			eventTaskID: eventTaskID,
			eventUserID: eventUserID
		});

		await this.fetchEventTasks({ eventId: this.eventId });
		this.setActivity();
	}

    public async onCompleteTask(completedTaskLine: any) {
		const completeTaskPayload: CompleteTaskPayload = {
			EventID: completedTaskLine.eventID,
			EventTaskID: completedTaskLine.eventTaskID,
			TaskComplete: completedTaskLine.completed,
			Result: completedTaskLine.result || "",
			taskData: JSON.stringify(completedTaskLine.taskData)
		};

		await this.completeTask(completeTaskPayload);
		this.setActivity();

        this.currentTask = completedTaskLine;
        if (completeTaskPayload.TaskComplete) {
            // delay before moving to the next task
            setTimeout(() => {
                this.next();
            }, 1000);
        }
	}    

    private onSlideStart(slide): void {
		this.currentTask = null;
		this.sliding = true;
	}

	private onSlideEnd(slide): void {
		this.currentSlide = slide;
		this.currentTask = this.tasks[slide];
		this.sliding = false;
	}

    private get isFirstAction(): boolean {
		return this.currentSlide == 0;
	}

	private get isLastAction(): boolean {
		// account for zero index
		return this.currentSlide == this.tasks.length - 1;
	}

    private reDoTask(task: Task): void {
		// On redo, set the current task to not completed
        this.onCompleteTask({
            ... task,
			completed: false
        })
	}

    private prev(): void {
        this.taskCarousel.prev();
	}

	private next(): void {
        this.taskCarousel.next();
	}

    private displayCompletedTasks() {
        this.isRedoing = true;
		// delay to give the carousel time to re-render
		setTimeout(() => {
		 	this.taskCarousel.setSlide(0);
		}, 1000);
	}
}
